import Button from '@components/Button';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { useTranslation } from 'react-i18next';

import useSignUp from './hooks/useSignUp';

function SignUpButton() {
    const { t } = useTranslation('signUp');
    const { signUpEnabled, signUp } = useSignUp();
    const project = useProject();
    return (
        <Wrapper>
            <Button fullWidth disabled={!signUpEnabled}
                onClick={signUp}>
                {project?.features.authenticationEnabled ? t('button.identify') : t('button.complete')}
            </Button>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 20px 20px calc(var(--safe-area-bottom) + 20px);
    width: 100%;
`;

export default SignUpButton;
